<template>
  <div>
    <div class="header-title">
      专题管理
      <div class="right">
        <el-button type="primary" size="small" @click="contestList()">添加应用</el-button>
      </div>
    </div>
    <el-divider></el-divider>
    <el-dialog title="添加应用" class="app_add" @close="close()" :visible.sync="dialogFormVisible" width="50%">
      <!-- <div class="content-header">
        <el-input
          size="middle"
          v-model="pickData.key"
          @keyup.enter.native="search()"
          placeholder="搜索应用"
          class="search"
        ></el-input>
        <el-select
          v-model="pickData.type"
          placeholder="内容分类"
          size="middle"
          class="type"
        >
          <el-option
            v-for="item in type"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div> -->
      <el-checkbox-group v-model="contestIds">
        <el-checkbox v-for="item in pickList" :label="item.id" :title="item.title" class="pick-item" :key="item.id">{{ item.title }}</el-checkbox>
      </el-checkbox-group>
      <el-pagination @current-change="pageChange" background layout="total, prev, pager, next" :total="paginator.itemCount" :page-size="paginator.perPageCount" v-if="paginator"
        hide-on-single-page></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addContest()">添 加</el-button>
        <el-button @click="close()">取 消</el-button>
      </div>
    </el-dialog>
    <el-card class="contest_item" v-for="item in contests" :key="item.id">
      <img :src="common.filepath(item.courseSet.cover.middle)" alt="" />
      <div class="info">
        <div class="title" v-if="item.courseSet.type=='contest'">
          <router-link :to="{name: 'special-introduce',params: { competitionId: item.id, classroomId: $route.params.classroomId, replayType: 2}}">{{ item.courseSet.title }}
          </router-link>
        </div>
        <div class="title" v-if="item.courseSet.type=='training'">
          <router-link :to="{name: 'train-special-index', params: { competitionId: item.id, classroomId: $route.params.classroomId, replayType: 2 }}">{{ item.courseSet.title }}
          </router-link>
        </div>
        <div class="desc">{{ item.courseSet.intro }}</div>
        <div class="creator">
          创建者：{{ users[item.courseSet.creator]["nickname"] }}
        </div>
      </div>
      <div class="delete">
        <i class="el-icon-close" @click="remove(item.id)"></i>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getClassroomContest,
  getClassroomPick,
  searchClassroomPick,
  addClassroomContest,
  removeClassroomCompetition
} from "@/api/classroom";
import qs from "qs";
export default {
  data() {
    return {
      contests: null,
      users: null,
      dialogFormVisible: false,
      pickList: null,
      pickData: {
        key: "",
        type: "",
        page: 1
      },
      contestIds: [],
      paginator: null,
      type: [
        {
          value: "",
          label: "所有"
        },
        {
          value: "contest",
          label: "比赛"
        },
        {
          value: "training",
          label: "训练"
        }
      ]
    };
  },
  methods: {
    handle() {
      getClassroomContest(this.$route.params.classroomId).then(response => {

        this.users = response.data.users;
        this.contests = response.data.courses;
      });
    },
    contestList() {
      this.dialogFormVisible = true;
      let params = {};

      if (this.pickData.page > 1) {
        params["page"] = this.pickData.page;
      }

      if (this.pickData.type) {
        params["type"] = this.pickData.type;
      }
      getClassroomPick(this.$route.params.classroomId, params).then(
        response => {

          this.paginator = response.data.paginator;
          this.pickList = response.data.courseSets;
        }
      );
    },
    addContest() {
      let ids = [];
      this.contestIds.forEach(item => {
        ids.push(item + ":" + item);
      });
      ids = ids.join(",");
      addClassroomContest(
        this.$route.params.classroomId,
        qs.stringify({ ids: ids })
      ).then(response => {
        this.$message.success({
          message: "添加成功",
          duration: 2000
        });
        this.handle();
        this.close();
      });
    },
    remove(competitionId) {
      this.$confirm("是否要从组合里移除该应用？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        removeClassroomCompetition(
          this.$route.params.classroomId,
          competitionId
        ).then(response => {

          if (response.code == 200) {
            this.$message.success({
              message: "删除成功"
            });
            this.handle();
          } else {
            this.$message.error({
              message: "删除失败"
            });
          }
        });
      });
    },
    search() {
      this.pickData.page = 1;

      if (this.pickData.key) {
        searchClassroomPick(
          this.$route.params.classroomId,
          qs.stringify({ key: this.pickData.key })
        ).then(response => {

          this.paginator = response.data.paginator;
          this.pickList = response.data.courseSets;
          this.pickData.key = "";
        });
      } else {
        this.contestList();
      }
    },
    close() {
      this.dialogFormVisible = false;
      this.pickList = null;
      this.pickData = {
        key: "",
        type: "",
        page: 1
      };
    },
    pageChange(val) {
      this.pickData.page = val;
      this.contestList();
    }
  },
  mounted() {
    this.handle();
  }
};
</script>

<style scoped lang="less">
.header-title {
  position: relative;
  background: #fff;
  .right {
    margin-top: -10px;
  }
}
.contest_item {
  margin-bottom: 10px;
  /deep/ .el-card__body {
    overflow: hidden;
    padding: 10px 20px;
    img {
      width: 120px;
      height: 120px;
      margin-right: 15px;
      float: left;
    }
    .info {
      width: calc(100% - 180px);
      float: left;
      .title {
        font-size: 18px;
        font-weight: 600;
        line-height: 34px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .desc {
        height: 66px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .creator {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .delete {
      width: 45px;
      height: auto;
      float: left;
      text-align: right;
      font-size: 20px;
      i {
        cursor: pointer;
      }
    }
  }
}
.app_add {
  .content-header {
    margin-bottom: 15px;
    > * {
      margin-right: 10px;
    }
    .search {
      width: 250px;
    }
    .type {
      width: 200px;
    }
  }
  .pick-item {
    width: calc(25% - 10px);
    box-sizing: border-box;
    margin-bottom: 20px;
    margin-right: 10px;
    /deep/ .el-checkbox__label {
      width: calc(100% - 24px);
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
</style>
